import { observer } from 'mobx-react-lite';
import { CSSProperties, useEffect, useState } from 'react';
import {
  Image,
  LabelProps,
  SemanticShorthandItem,
  SemanticSIZES,
} from 'semantic-ui-react';
import { FileUploadInterface } from '../../app/models/Profile';
import { useStore } from '../../app/stores/store';

type Props = {
  imageUrl: string | undefined;
  avatar?: boolean;
  defaultUrl?: string;
  size?: SemanticSIZES;
  spaced?: boolean | 'left' | 'right';
  fluid?: boolean;
  style?: CSSProperties;
  label?: SemanticShorthandItem<LabelProps>;
  handleClick?: (url: FileUploadInterface) => void;
};

function ImageTag({
  imageUrl = '',
  avatar = false,
  defaultUrl = '/assets/documents.jpg',
  size,
  spaced,
  fluid,
  style,
  handleClick,
  label,
}: Props) {
  const { commonStore } = useStore();
  const [imageSrc, setImageSrc] = useState('');

  useEffect(() => {
    if (
      commonStore.devEnv &&
      !imageUrl?.includes('https://res.cloudinary.com')
    ) {
      const splitPath: string[] = imageUrl?.split('build') || [];
      setImageSrc(splitPath[1] ? splitPath[1] : imageUrl);
    } else {
      setImageSrc(imageUrl || '');
    }
    // eslint-disable-next-line
  }, [imageUrl]);

  return (
    <Image
      avatar={avatar}
      src={imageSrc !== '' ? imageSrc : defaultUrl}
      size={size}
      spaced={spaced}
      fluid={fluid}
      style={style}
      onClick={handleClick !== undefined ? handleClick : undefined}
      label={label}
      onError={(img: any) =>
        (img.target.src = defaultUrl || '/assets/user.png')
      }
    />
  );
}

export default observer(ImageTag);
